"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
var _withSizePresets = _interopRequireDefault(require("../withSizePresets"));
/* eslint-disable max-len */

var NoShipTo = function NoShipTo(props) {
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, (0, _extends2["default"])({
    viewBox: "0 0 25 25"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.8,16.2 L4.2,15.9 L4.2,8.6 L9.7,11.4 L11,10 L9.6,9.3 L13.5,7.5 L16.8,4.2 L12.2,2.1 L2.4,6.6 L2.4,17 L3.5,17.5 L4.8,16.2 Z M12.3,4 L14.7,5.1 L7.6,8.3 L5.3,7.2 L12.3,4 Z M21.7,6.4 L22.1,6.6 L22.1,17 L12.2,21.9 L8.2,19.9 L9.5,18.6 L11.3,19.5 L11.3,16.8 L13,15.1 L13,19.6 L20.3,16 L20.3,8.6 L18.7,9.4 L21.7,6.4 Z M5.6,11.2 L8.5,12.6 L6.1,15 L5.6,14.8 L5.6,11.2 Z M1.4,24.6 L0,23.2 L23.2,0 L24.6,1.4 L1.4,24.6 Z",
    fillRule: "nonzero"
  })));
};
var _default = (0, _withSizePresets["default"])(25, 25)(NoShipTo);
exports["default"] = _default;
//# sourceMappingURL=NoShipTo.js.map